import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMaritalStatus } from "src/models/HumanResources/MaritalsStatus.models";

interface MaritalStatusState {
  maritalsStatus: IMaritalStatus[];
  maritalStatusToEdit: IMaritalStatus | null;
}

const initialState: MaritalStatusState = {
  maritalsStatus: [],
  maritalStatusToEdit: null,
};

const MaritalStatusSlice = createSlice({
  name: "MaritalStatus",
  initialState,
  reducers: {
    setMaritalStatusList: (state, action: PayloadAction<IMaritalStatus[]>) => {
      state.maritalsStatus = action.payload;
    },
    concatListMaritalStatus: (
      state: MaritalStatusState,
      action: PayloadAction<IMaritalStatus[]>
    ) => {
      state.maritalsStatus = [...state.maritalsStatus.concat(action.payload)];
    },
    setMaritalStatusToEdit: (
      state,
      action: PayloadAction<IMaritalStatus | null>
    ) => {
      state.maritalStatusToEdit = action.payload;
    },
    addMaritalStatus: (state, action: PayloadAction<IMaritalStatus>) => {
      state.maritalsStatus.push(action.payload);
    },
    updateMaritalStatus: (state, action: PayloadAction<IMaritalStatus>) => {
      let itemIndex = state.maritalsStatus.findIndex(
        item => item.maritalStatusId === action.payload.maritalStatusId
      );
      if (itemIndex !== -1) state.maritalsStatus[itemIndex] = action.payload;
    },
    deleteMaritalStatus: (state, action: PayloadAction<number>) => {
      const newArray = state.maritalsStatus.filter(
        item => item.maritalStatusId !== action.payload
      );
      state.maritalsStatus = newArray;
    },
  },
});

export const {
  setMaritalStatusList,
  concatListMaritalStatus,
  setMaritalStatusToEdit,
  addMaritalStatus,
  updateMaritalStatus,
  deleteMaritalStatus,
} = MaritalStatusSlice.actions;

export default MaritalStatusSlice.reducer;
